import CssfBusinessSkillsSection from "./CssfBusinessSkillsSection";
import CssfDiplomasSection from "./CssfDiplomasSection";
import CssfExperiencesSection from "./CssfExperiencesSection";
import CssfLanguagesSkillsSection from "./CssfLanguagesSkillsSection";
import CssfUserInformationSection from "./CssfUserInformationSection";


export default function CssfMainContent() {

    return (
        <main className="content-block cssf-responsive">
            <div className="card-body">
                <CssfUserInformationSection/>
                <CssfExperiencesSection/>
                <CssfDiplomasSection/>
                <CssfLanguagesSkillsSection/>
                <CssfBusinessSkillsSection/>
            </div>
        </main>
    );
}